const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckeredFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "sports_score",
    d: "M3.85672 1.57143H5.42815V0H3.85672V1.57143ZM6.99958 1.57143V0H8.57101V1.57143H6.99958ZM3.85672 7.85714V6.28571H5.42815V7.85714H3.85672ZM10.1424 4.71429V3.14286H11.7139V4.71429H10.1424ZM10.1424 7.85714V6.28571H11.7139V7.85714H10.1424ZM6.99958 7.85714V6.28571H8.57101V7.85714H6.99958ZM10.1424 1.57143V0H11.7139V1.57143H10.1424ZM5.42815 3.14286V1.57143H6.99958V3.14286H5.42815ZM0.713867 21.0714V0H2.2853V1.57143H3.85672V3.14286H2.2853V4.71429H3.85672V6.28571H2.2853V21.0714H0.713867ZM8.57101 6.28571V4.71429H10.1424V6.28571H8.57101ZM5.42815 6.28571V4.71429H6.99958V6.28571H5.42815ZM3.85672 4.71429V3.14286H5.42815V4.71429H3.85672ZM6.99958 4.71429V3.14286H8.57101V4.71429H6.99958ZM8.57101 3.14286V1.57143H10.1424V3.14286H8.57101Z",
    fill: "#1C1B1F",
    style: {
      fill: "#1C1B1F",
      fill: "color(display-p3 0.1098 0.1059 0.1216)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckeredFlag);
export default __webpack_public_path__ + "static/media/checkered-flag.e8f3266e51281596115f7a5d7260ebf5.svg";
export { ForwardRef as ReactComponent };